export const BASE_URL = "https://materialblog-server-production.up.railway.app";
